/**
 * Mixin to trigger split tabs
 * expects consuming component to define `splitTabData`
 * `splitTabData`should provide tab `tabKey`, the `eventName` to be fired and a default tab value
 * an `article` and a `splitTabs` array should be also be defined
 */

const model = require('model/model');
const analyticsUtilities = require('utilities/analyticsUtilities');

module.exports = {
	modelData: {
		splitTab: 'splitTab'
	},
	data() {
		return {
			article: {},
			splitScreen: false,
			splitTabs: [],
			splitTabData: {
				tabKey: '',
				defaultTab: '',
				eventName: ''
			}
		};
	},
	beforeDestroy() {
		model.remove('splitTab');
	},
	methods: {
		onSplitScreenClick() {
			const { tabKey, defaultTab, eventName } = this.splitTabData;
			const tabValue = this[tabKey];
			const { uuid: pid } = this.article;
			const splitTabs = this.splitTabs || [];
			const selectedSplitTab = splitTabs.find(t => t.id === tabValue);

			const splitScreen = !this.splitScreen;
			this.splitScreen = splitScreen;

			if (selectedSplitTab) {
				this[tabKey] = defaultTab;
			}

			if (splitScreen) {
				model.set('splitTab', (selectedSplitTab || splitTabs[0]).id);
			} else {
				model.remove('splitTab');
			}

			analyticsUtilities.fireEvent(eventName, {
				action_type: 'toggle_splitscreen',
				state: splitScreen,
				pid
			});
		}
	}
};
